import { render, staticRenderFns } from "./WithExcerptBig.vue?vue&type=template&id=ea94ed32&"
import script from "./WithExcerptBig.vue?vue&type=script&lang=ts&"
export * from "./WithExcerptBig.vue?vue&type=script&lang=ts&"
import style0 from "./WithExcerptBig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports